import React from 'react';

export const SmetterLogo = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="20" height="20" fill="#121212" />
            <path
                d="M14.9547 3.65086V16.237H17.9001V13.6749H19.6275V16.0851C19.6261 16.5645 19.4658 17.0237 19.1816 17.3626C18.8974 17.7015 18.5124 17.8927 18.1105 17.8945H14.7332C14.3313 17.8927 13.9463 17.7015 13.6621 17.3626C13.3779 17.0237 13.2176 16.5645 13.2162 16.0851V3.80934C13.2176 3.32887 13.3787 2.86867 13.6641 2.52954C13.9495 2.19041 14.3359 2 14.7387 2L18.116 2C18.517 2.00347 18.9006 2.19543 19.1836 2.53418C19.4665 2.87293 19.6261 3.33115 19.6275 3.80934V6.21299H17.9001V3.65086H14.9547ZM9.025 2H0.526367V3.66406H9.025V2ZM9.025 5.55925H1.47312V7.22331H9.025V5.55925ZM9.025 9.1185H1.47312V10.7826H9.025V9.1185ZM9.025 12.6777H0.526367V14.3418H9.025V12.6777ZM9.025 16.237H1.47312V17.9011H9.025V16.2304V16.237Z"
                fill="white"
            />
        </svg>
    );
};
